export const GET_PAYMENT_RESULT = "GET_PAYMENT_RESULT";

export const SET_CART = "SET_CART";